/**
 * ChPdfViewerEmbed — Swissmedic label viewer (Fachinformation /
 * Patienteninformation): the shared BilingualPdfViewerEmbed bound to
 * `/ch_pdf`.  The source is German, French or Italian (Latin script), so a
 * query is boxed on the page AND marked in the English panel.  The backend
 * picks the translation language from the document itself.
 */
import { forwardRef } from 'react';
import { chPdfApi } from '../../api/createViewerApi';
import { authApi } from '../../services/authApi';
import BilingualPdfViewerEmbed, {
  type BilingualPdfViewerEmbedProps,
  type BilingualPdfViewerHandle,
  type BilingualViewerConfig,
} from './BilingualPdfViewerEmbed';

export type ChPdfViewerHandle = BilingualPdfViewerHandle;

export const CH_CONFIG: BilingualViewerConfig = {
  viewerApi: chPdfApi,
  translate: (text, preserveHtml, docId, sectionId) =>
    authApi.translateChPdfText(text, preserveHtml, docId, sectionId),
  sourceLabel: 'Original',
  sourceName: 'original-language',
  titleSrcField: 'title_src',
  // German/French/Italian can't be told from English by script → search both.
  docSearch: 'both',
  translateTerm: (en, docId) => authApi.translateTermToSource('ch_pdf', en, docId),
};

const ChPdfViewerEmbed = forwardRef<ChPdfViewerHandle, BilingualPdfViewerEmbedProps>(
  function ChPdfViewerEmbed(props, ref) {
    return <BilingualPdfViewerEmbed ref={ref} config={CH_CONFIG} {...props} />;
  },
);

export default ChPdfViewerEmbed;
